import { generateHandleString } from 'utils/common';

function generateHandleValue([_val], state, { changeValue }) {
  const nameValue = state?.formState?.values?.name || '';
  const tagsValue = state?.formState?.values?.tags?.join(' ');

  const result = generateHandleString(nameValue, tagsValue);
  changeValue(state, 'handle', () => result);
}

export default generateHandleValue;
